
import React, { memo } from "react";

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import { IonAvatar, IonCol, IonGrid, IonInput, IonItem, IonLabel, IonList, IonListHeader, IonRow, IonText } from "@ionic/react";

import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    button: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    actionsContainer: {
      marginBottom: theme.spacing(2),
    },
    resetContainer: {
      padding: theme.spacing(3),
    },
  }),
);


const SaveAlumno = ({
  handleBack,
  formik: {
    isSubmitting,
    errors,
    values
  }
}: any) => {
  // console.log({ errors, values });

  const classes = useStyles();

  return (
    <>
      <IonGrid className="ion-padding-none">
        <IonRow>

          <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
            <IonItem lines="none">
              <IonLabel
              >
                <IonText style={{ fontWeight: 'bold' }}>
                  Padre/Madre
                </IonText>
              </IonLabel>
            </IonItem>
          </IonCol>

          <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
            <IonItem>
              <IonLabel
                position="floating"
              >
                <IonText style={{ fontWeight: 'bold' }}>
                  Nombre
                </IonText>
              </IonLabel>
              <IonInput
                readonly={true}
                value={`${values?.Padre?.Usuario?.nombre?.toUpperCase()} ${values?.Padre?.Usuario?.apellido?.toUpperCase()}`}
              />
            </IonItem>
          </IonCol>

          <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
            <IonItem>
              <IonLabel
                position="floating"
              >
                <IonText style={{ fontWeight: 'bold' }}>
                  Correo
                </IonText>
              </IonLabel>
              <IonInput
                readonly={true}
                value={values?.Padre?.Usuario?.email}
              />
            </IonItem>
          </IonCol>

          <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
            <IonItem>
              <IonLabel
                position="floating"
              >
                <IonText style={{ fontWeight: 'bold' }}>
                  Teléfono de emergencia
                </IonText>
              </IonLabel>
              <IonInput
                readonly={true}
                value={values?.Padre?.Usuario?.mobil}
              />
            </IonItem>
          </IonCol>

          <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">

            <IonList>
              <IonListHeader style={{ fontWeight: 'bold' }}>
                Hijo (s)
              </IonListHeader>

              {values?.Padre?.Alumno?.map(({
                nombre,
                fecha_nacimiento,
                alergias,
                tipo_sangre,
                imagen
              }: any, index: number) => {
                return (
                  <IonItem key={index}>
                    <IonAvatar slot="start">
                      <img src={imagen} alt={`Fotografia de ${imagen}`} />
                    </IonAvatar>
                    <IonLabel>
                      <h2>{nombre}</h2>
                      <h3>Fecha de nacimiento: {fecha_nacimiento}</h3>
                      <p>Alergias: {alergias}</p>
                      <p>Tipo de sangre: {tipo_sangre}</p>
                    </IonLabel>
                  </IonItem>
                )
              })}

            </IonList>

          </IonCol>

          <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">

            <IonList>
              <IonListHeader style={{ fontWeight: 'bold' }}>
                Personas autorizadas para recoger
              </IonListHeader>

              {values?.Padre?.PersonasAutorizadasRecoger?.map(({
                nombre,
                apellido,
                parentesco,
                imagen
              }: any, index: number) => {
                return (
                  <IonItem key={index}>
                    <IonAvatar slot="start">
                      <img src={imagen} alt={`Fotografia de ${imagen}`} />
                    </IonAvatar>
                    <IonLabel>
                      <h2>{nombre} {apellido}</h2>
                      <h3>{parentesco}</h3>
                    </IonLabel>
                  </IonItem>
                )
              })}

            </IonList>

          </IonCol>

          <div className={classes.actionsContainer}>
            <div className="ion-padding">
              <Button
                onClick={handleBack}
                className={classes.button}
              >
                Anterior
              </Button>

              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={classes.button}
                disabled={isSubmitting}
              >
                Finalizar el registro
              </Button>
            </div>
          </div>

        </IonRow>

      </IonGrid>

    </>
  );
};

export default memo(SaveAlumno);